// Basic Usage
// <ChartPie ref="chart" data={{
//   "series": [
//     {
//       "name": "> 30 days",
//       y: 3
//
//     },
//     {
//       "name": "> 10 days",
//       y: 2
//     },
//     {
//       "name": "> 5 days",
//       y: 4
//     }
//   ],
// }}/>

import React, { Component, PropTypes } from "react";
// import ReactHighcharts from 'react-highcharts';

import config from "./ChartPieAdvConfig";
import { NitroLoading, NitroContentNotAvailable } from "nitro-components";

import Highcharts from "highcharts";
import exporting from "highcharts/modules/exporting";
import RHC from "react-highcharts";

import smplTheme from "../highcharts-themes/smpl";
import { getColour } from "../highcharts-themes/helper";

exporting(Highcharts);
const ReactHighcharts = RHC.withHighcharts(Highcharts);

class ChartBar extends Component {
  export = option => {
    const { data } = this.props;
    if (data.series[0].name) {
      const chart = this.refs.chart;
      const svg = chart.getChart().getSVG();
      this.props.exportDocument(svg, option);
    }
  };

  render() {
    const escapeHtml = text => {
      let map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      };

      return text.replace(/[&<>"']/g, function(m) {
        return map[m];
      });
    };

    const { data, plotOptions, dataType } = this.props;

    if (data) {
      const series = data.series.map(data => {
        return {
          name: escapeHtml(data.name),
          y: data.y || data.data[0].y,
          filters: data.data && data.data[0].filters
        };
      });

      let plotConfig = { ...config.plotOptions };

      if (dataType === "Currency") {
        plotConfig.pie.dataLabels.formatter = function() {
          return parseFloat(this.y).toLocaleString("en-AU", {
            style: "currency",
            currency: "AUD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        };
        config.legend.labelFormatter = function() {
          return (
            '<div style="width:200px;display:flex;flex-direction:column"><span>' +
            this.name +
            "   " +
            '</span><span style="color:inherit;font-size:10px;padding-top: 8px;">' +
            parseFloat(this.y).toLocaleString("en-AU", {
              style: "currency",
              currency: "AUD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }) +
            "</span></div>"
          );
        };
        plotConfig.pie.tooltip.pointFormatter = function() {
          return parseFloat(this.y).toLocaleString("en-AU", {
            style: "currency",
            currency: "AUD",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        };
      } else {
        plotConfig.pie.dataLabels.formatter = function() {
          return this.y;
        };
        plotConfig.pie.tooltip.pointFormatter = function() {
          return this.y;
        };
        config.legend.labelFormatter = function() {
          return (
            '<div style="width:200px; display:flex;flex-direction:column"><span>' +
            this.name +
            "   " +
            '</span><span style="color: inherit;font-size:10px;padding-top: 8px;">' +
            this.y +
            "</span></div>"
          );
        };
      }

      const chartConfig = Object.assign({}, config, {
        series: [
          {
            name: "",
            colorByPoint: true,
            data: series
          }
        ],
        // xAxis: {
        //   categories: data.xAxis.categories
        // },
        //
        plotOptions: {
          ...plotConfig,
          ...plotOptions
        },
        exporting: {
          sourceHeight: 720,
          sourceWidth: 1080,
          scale: 1.5,
          buttons: {
            contextButton: {
              enabled: false
            }
          }
        }
      });

      // If data has yAxis
      // if(data.yAxis && data.yAxis.length){
      //
      //   chartConfig.yAxis = [];
      //   data.yAxis.forEach((yAxis) => {
      //     // Merge defaults from config with the yAxis data
      //     yAxis = Object.assign({}, config.yAxis, yAxis);
      //     chartConfig.yAxis.push(yAxis);
      //   });
      //
      // }

      const { id } = chartConfig;

      // Get all series that has data value greater than or less than 0;
      // const seriesWithData = data.series.filter((series) => {
      //   const seriesDataGtZero = series.data.filter((seriesData) => (seriesData !== 0));
      //   return seriesDataGtZero.length > 0;
      // });

      // Apply the theme
      Highcharts.theme = smplTheme;
      const newTheme = {
        ...smplTheme,
        colors: getColour(data.series.length)
      };
      Highcharts.setOptions(newTheme);

      if (!series.length) {
        return <NitroContentNotAvailable />;
      }

      return (
        <ReactHighcharts
          ref="chart"
          config={chartConfig}
          domProps={{
            id
          }}
        />
      );
    } else {
      return <NitroLoading center thickness={2} size={24} />;
    }
  }
}

ChartBar.propTypes = {
  dataType: PropTypes.string,
  exportOptions: PropTypes.object,
  plotOptions: PropTypes.object,
  data: PropTypes.object.isRequired,
  error: PropTypes.bool, // TODO .isRequired
  exportDocument: PropTypes.func
};

export default ChartBar;

export const categoryPieFormatter = data => {
  return {
    series: [
      ...data.map(item => {
        return {
          name: item.Category,
          y: parseFloat(parseFloat(item.CategoryValue).toFixed(2))
        };
      })
    ]
  };
};



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartPieAdv.js